import { inject, Injectable, signal } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IRouteReplayResponse } from '../models/multi-route.model';
import { RouteReplayResponse, Vehicle, RouteData } from '../models/route-replay-response.model';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RouteReplayDataService {
  http = inject(HttpClient);
  buid = signal<string>('');
  selectedRouteId = signal<string>('');
  routeReplayData = signal<RouteReplayResponse | null>(null);
  source = signal<string>('');

  // BehaviorSubjects for route data and selected vehicles
  private routeDataSubject = new BehaviorSubject<RouteReplayResponse | null>(null);
  routeData$ = this.routeDataSubject.asObservable();

  // Multi-route support
  private multiRouteDataSubject = new BehaviorSubject<RouteData[]>([]);
  multiRouteData$ = this.multiRouteDataSubject.asObservable();

  private selectedVehiclesSubject = new BehaviorSubject<Vehicle[]>([]);
  selectedVehicles$ = this.selectedVehiclesSubject.asObservable();

  constructor() { }

  updateBuid(buid: string,source?: string): void {
    this.buid.set(buid);
    if(source) this.source.set(source);
  }

  updateRouteData(data: RouteReplayResponse): void {
    this.routeDataSubject.next(data);
  }

  updateMultiRouteData(routes: RouteData[]): void {
    this.multiRouteDataSubject.next(routes);
  }

  updateSelectedVehicles(vehicles: Vehicle[]): void {
    this.selectedVehiclesSubject.next(vehicles);
  }

  getRouteReplayData(routeId: string, date: string, shift: string): Observable<RouteReplayResponse> {
    // This would be the actual API call
    return this.http.get<RouteReplayResponse>(
      `${environment.API_URL}/route-replay/${this.buid()}/${routeId}?date=${date}&shift=${shift}`
    );
  }

  getRouteDirection(): string {
    // Get direction from the first route in multi-route data
    const routes = this.multiRouteDataSubject.value;
    if (routes && routes.length > 0) {
      return routes[0].direction || 'Login';
    }
    
    // Fallback to single route data
    const singleRoute = this.routeDataSubject.value;
    return singleRoute?.direction || 'Login';
  }
}
